const accessibilityGradeIcons = (value) => {
  switch (value) {
  case 'accessible':
    return 'fa fa-check text-success'
  case 'partially_accessible':
    return 'fa fa-exclamation-triangle text-warning'
  case 'not_accessible':
    return 'fas fa-times text-danger'
  }
}

export {accessibilityGradeIcons}
